import { getThumbBySize } from '../../../../../../util/photo';
import { IMAGE_SIZE_CODE } from '../../../../../../constants/image-size-codes';

/**
 * Calculates the duration of the slideshow or a portion of it
 *
 * @param {Array} [slides] The slides array
 * @param {Number} [defaultDuration] The slideshow's default MS duration
 * @param {Number} [stopIndex] The stop index, given we want the time up to a certain slide
 */
export const calculateSlideshowDuration = (
  slides,
  defaultDuration,
  stopIndex = null,
) => {
  if (!slides) {
    return 0;
  }

  if (stopIndex !== null) {
    return slides.slice(0, stopIndex).reduce(sum => sum + defaultDuration, 0);
  }

  return slides.reduce(sum => sum + defaultDuration, 0);
};

/**
 * Retrieves the appropriate Slide image URL based off the given slide data
 *
 * @param {Object} slide the slideshow's slide to get the image for
 * @param {String} imageSizeCode the image size code to get the thumb for if getting thumbs
 *
 * @returns {string} the appropriate thumbnail or asset image URL
 */
export const getSlideImageUrl = (
  slide,
  imageSizeCode = IMAGE_SIZE_CODE.SMALL2X,
) => {
  if (!slide) {
    return '';
  }

  if (slide.photo) {
    const thumbnail = getThumbBySize(
      slide.photo.watermarked_urls ?? slide.photo.thumbnail_urls,
      imageSizeCode,
    );

    return thumbnail?.url;
  }

  if (slide.asset_image) {
    return slide.asset_image.url;
  }

  return '';
};
